import { ReadonlyCollection } from "@ioip/core/lib";
import CField from "./CField";
import CControl from "./CControl";
import { CForm } from "./JSForm";
import { IFieldSchema } from "./IFieldSchema";

class CRow extends CField {

    #schema: IFieldSchema;
    #form: CForm;
    #children: ReadonlyCollection<CControl> = null;

    constructor(form: CForm, schema: IFieldSchema) {
        super(schema);
        this.#form = form;
        this.#schema = schema;
    }

    get order(): number {
        return this.#schema.order;
    }

    get children(): ReadonlyCollection<CControl> {
        if (this.#children == null) {
            const id = this.id.toString();
            const children = this.#form.fields.where(x => x.parentId.toString() == id).cast<CControl>().toArray();
            this.#children = new ReadonlyCollection<CControl>(children);
        }
        return this.#children;
    }

}

export default CRow;